import React from 'react'
import './index.css'

const AnimateLoad = WrappedComponent => {
    return props => (
        <div className="load-fade-in visible">
            <WrappedComponent {...props} />
        </div>
    )
}

export default AnimateLoad
